import { render, staticRenderFns } from "./mitra.vue?vue&type=template&id=75de26a0"
import script from "./mitra.vue?vue&type=script&lang=js"
export * from "./mitra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports